import fetchIntercept from 'fetch-intercept';

const registerInterceptors = () => {
  // Return the unregister function for cleanup if needed
  return fetchIntercept.register({
    request: (url, config) => {
      console.log('URL intercepted:' + url);
      const accessToken = JSON.parse(sessionStorage.getItem('access_token') || '{}');
      const currentTime = Math.round(new Date().getTime() / 1000);
      const expiredTokenTime = accessToken?.issuedAt + accessToken?.expiresIn;
      if (accessToken?.accessToken && currentTime >= expiredTokenTime) {
        window.location.href = process.env.REACT_APP_LOGOUT_URI;
        return new Promise(() => console.log('Token expired'));
      }
      return Promise.resolve([url, config]);
    }
  });
};

export default registerInterceptors;
